import { useMediaQuery, useTheme } from '@mui/material';
import { useFindActiveBanners } from '../../../../../services/modules/banners/banners.queries';
import { BannerSlide } from '../components/BannerCarousel/bannerCarousel.types';

export const useStoreBanners = () => {
  const theme = useTheme();
  const isMobileWidth = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const { data, isLoading } = useFindActiveBanners();

  const slides: BannerSlide[] = (data?.data ?? []).map((banner) => ({
    id: banner.id,
    name: banner.name,
    imageUrl: isMobileWidth ? banner.mobileImageUrl || banner.imageUrl : banner.imageUrl,
    link: banner.link,
  }));

  return { slides, isLoading };
};
